// This allows us to load Angular components on legacy server-side pages.
import {
  NgModuleFactoryLoader,
  NgModule,
  ErrorHandler,
  SystemJsNgModuleLoader,
  ViewChild,
  ViewContainerRef,
  ANALYZE_FOR_ENTRY_COMPONENTS,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ROUTES } from '@angular/router';
import { AuthModule } from '@shared/auth';
import { TrackingModule, CustomErrorHandler } from '@shared/tracking';
import { DatastoreModule } from '@shared/datastore';
import { CookieModule } from '@shared/cookie';
import { environment } from '../environments/environment';
import { components } from './components';
import { CompatComponent } from './compat.component';

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CookieModule.forRoot(),
    AuthModule.initialize(environment.authConfig),
    DatastoreModule.initialize(environment.datastoreConfig),
    TrackingModule.initialize(environment.trackingConfig),
  ],
  declarations: [CompatComponent],
  providers: [
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader },
    // This is a hack to make the CLI code splitting and ngc lazy module
    // analysis and compilation work, pending proper fix in
    // https://github.com/angular/angular-cli/issues/4541
    { provide: ROUTES, useValue: components, multi: true },
  ],
  bootstrap: [CompatComponent],
})
export class CompatModule {}



// WEBPACK FOOTER //
// ./src/compat/compat.module.ts